import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import Sheet from 'react-modal-sheet';
import { colors } from '../color';
import { FaCheckCircle, FaCrosshairs } from 'react-icons/fa';
import { ServerIP } from '../component/ServerIP';
import { io } from 'socket.io-client';
import { CommentOutlined, EditOutlined, StarFilled } from '@ant-design/icons'
import Loader from '../component/Loader';
import WarningComponent from '../component/WarningComponent';
import { color } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { AutoSizer, CellMeasurerCache, List } from 'react-virtualized';




const ClientRoutingMap = ({ }) => {

    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('orderId');


    // const mapContainer = useRef(null);
    // const map = useRef(null);
    // const center = { lng: 18.32, lat: -72.17 };
    const [location, setLocation] = useState([18.32, -72.17]);

    // const [zoom] = useState(12);

    const [isVisible, setIsVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [address, setAddress] = useState([])
    const [addressType, setAddressType] = useState('');


    const [price, setPrice] = useState(0)
    const [time, setTime] = useState(0)
    const [kilometer, setKilometer] = useState(0)

    const [pickupAddress, setPickupAddress] = useState('Chargement...');
    const [deliveredAddress, setDeliveredAddress] = useState('Chargement...');
    const [promoStatut, setPromoStatut] = useState(false);
    const [promoDiscount, setPromoDiscount] = useState(0);
    const [promoMaxPriceAmount, setPromoMaxPriceAmount] = useState(0);
    const [discountType, setDiscountType] = useState('');

    const [modalVisible, setModalVisible] = useState(false);
    const [driver, setDriver] = useState({});


    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }


    function haversinePrice(lat1, lon1, lat2, lon2) {
        const earthRadius = 6371;
        const dLat = deg2rad(lat2 - lat1);
        const dLon = deg2rad(lon2 - lon1);

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = earthRadius * c;

        const distanceByMeter = distance * 1000

        const fee = parseInt(distanceByMeter * (100 / 1000) / 1)

        return fee;
    }


    function haversine(lat1, lon1, lat2, lon2) {
        const earthRadius = 6371;
        const dLat = deg2rad(lat2 - lat1);
        const dLon = deg2rad(lon2 - lon1);

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = earthRadius * c;

        return distance;
    }


    useEffect(() => {
        // if (map.current) return;

        // map.current = new L.Map(mapContainer.current, {
        //     center: L.latLng(center.lat, center.lng),
        //     zoom: zoom,
        //     zoomControl: false,
        // });


        // L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        //     subdomains: 'abcd',
        //     maxZoom: 20,
        //     minZoom: 3,
        // }).addTo(map.current);

        getCoordinate();

    }, []);
    // center.lat, center.lng, zoom

    // let userMarker = useRef();
    // let userMarker2 = useRef();

    const getCoordinate = async () => {
        try {
            const res = await axios.get(`${ServerIP}/mission/getCoordinateMissionClient/${orderId}`);
            if (res.status === 200) {

                // // Pickup marker
                // const userIcon2 = L.icon({
                //     iconUrl: require('../data/IconImageMap/riseHand.png'),
                //     iconSize: [25, 36],
                //     iconAnchor: [12, 35]
                // });

                // if (userMarker2.current) {
                //     userMarker2.current.remove();
                // }

                // userMarker2.current = L.marker([res.data.pickupLatitude, res.data.pickupLongitude], { icon: userIcon2 }).addTo(map.current);

                // Delivered marker
                // setLocation([res.data.deliveredLatitude, res.data.deliveredLongitude]);

                // if (userMarker.current) {
                //     userMarker.current.remove();
                // }

                // userMarker.current = L.marker([res.data.deliveredLatitude, res.data.deliveredLongitude], {
                //     icon: L.icon({
                //         iconUrl: require('../data/IconImageMap/Location2.png'),
                //         iconSize: [30, 41],
                //         iconAnchor: [12, 41]
                //     }),
                //     draggable: false
                // }).addTo(map.current);

                // Calculate route using TomTom Routing API
                // const response = await axios.get(`https://api.tomtom.com/routing/1/calculateRoute/${res.data.pickupLatitude},${res.data.pickupLongitude}:${res.data.deliveredLatitude},${res.data.deliveredLongitude}/json`, {
                //     params: {
                //         key: process.env.REACT_APP_TOMTOM_API,
                //         traffic: false
                //     }
                // });



                // const coordinates = response.data.routes[0].legs[0].points.map(point => [point.latitude, point.longitude]);
                // console.log(coordinates);

                // const latLngs = coordinates.map(coord => L.latLng(coord[0], coord[1]));
                // console.log(latLngs)

                // const polyline = L.polyline(latLngs, {
                //     color: colors.secondary,
                //     weight: 5,
                //     opacity: 0.8
                // }).addTo(map.current);


                //Price and dataLocation
                // const price = haversinePrice(res.data.pickupLatitude, res.data.pickupLongitude, res.data.deliveredLatitude, res.data.deliveredLongitude)
                setPrice(res.data.price)


                // const distance = haversine(res.data.pickupLatitude, res.data.pickupLongitude, res.data.deliveredLatitude, res.data.deliveredLongitude) * 1000
                // const vitesse = 500
                // let temps = distance / vitesse;
                // temps = Math.round(temps);
                // setTime(temps)

                // const kilometer = haversine(res.data.pickupLatitude, res.data.pickupLongitude, res.data.deliveredLatitude, res.data.deliveredLongitude).toFixed(2)
                // setKilometer(kilometer)

                setPickupAddress(res.data.pickupAddress)
                setDeliveredAddress(res.data.deliveredAddress)
                setPromoStatut(res.data.missions.promoStatut)
                setPromoDiscount(res.data.missions.promoDiscount)
                setDiscountType(res.data.missions.discountType)
                setPromoMaxPriceAmount(res.data.missions.promoMaxPriceAmount)

                // map.current.flyTo([res.data.pickupLatitude, res.data.pickupLongitude], map.current.getZoom() + 2);
            }
        } catch (error) {
            console.error('Erreur lors du calcul de l\'itinéraire:', error);
        }
    };


    const formatBalance = (balance) => {
        let balanceString = balance.toString();

        const length = balanceString.length;

        let startPoint = length % 3;

        startPoint = startPoint === 0 ? 3 : startPoint;

        while (startPoint < length) {
            balanceString = balanceString.slice(0, startPoint) + ',' + balanceString.slice(startPoint);
            startPoint += 4;
        }

        return balanceString
    };


    const changeAddress = async () => {

        const data = {
            address: address,
            addressType: addressType,
        }

        const response = await axios.patch(`${ServerIP}/mission/updateAddressMission/${orderId}`, data)

        if (response.status === 200) {
            getCoordinate();
            setIsVisible(false);
            setAddress([]);
            setAddressType('')
        }

    };

    //Coordinate

    const intervalIdRef1 = useRef(null);

    useEffect(() => {
        intervalIdRef1.current = setInterval(getRealTimePosition, 1000);

        return () => {
            if (intervalIdRef1.current) {
                clearInterval(intervalIdRef1.current);
            }
        }

    }, [])


    const getRealTimePosition = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 1000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);


        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };

    const getTimeFunc = (latitude, longitude) => {
        const vitesse = 300; // en mètres par seconde (environ 72 km/h)
        const distance = haversine(location[0], location[1], latitude, longitude) * 1000; // distance en mètres
        const temps = distance / vitesse; // temps en secondes
        return Math.round(temps); // renvoie le temps arrondi en secondes
    };




    //DriverPart

    const [driverMissions, setDriverMissions] = useState([])

    const intervalIdRef = useRef(null);
    const socketRef = useRef(null);

    useEffect(() => {

        if (!socketRef.current) {
            socketRef.current = io(process.env.REACT_APP_SERVER_IP, {
                withCredentials: true,
                transports: ["websocket", "polling"],
            });
        }

        socketRef.current.connect();

        socketRef.current.on('connect', () => {
            console.log('Socket connected:', socketRef.current.id);
            socketRef.current.emit('userMapConnected', orderId);
        });

        socketRef.current.on('disconnect', () => {
            console.log('Socket disconnected');
        });

        socketRef.current.on('sendDriverMission', (data) => {
            console.log('Received driver mission data:', data);
            setDriverMissions(data);
        });

        intervalIdRef.current = setInterval(fetchDriver, 5000);

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }

            if (socketRef.current) {
                socketRef.current.off('connect');
                socketRef.current.off('disconnect');
                socketRef.current.disconnect();
            }
        };
    }, []);


    const fetchDriver = async () => {
        if (socketRef.current && socketRef.current.connected) {
            console.log('Emitting sendLocation event');
            try {
                await socketRef.current.emit('fetchMission', { orderId });
            } catch (error) {
                console.error('Error emitting fetchMission:', error);
            }
        } else {
            console.error('Socket is not connected');
        }
    }


    const takeTask = async () => {
        try {
            setLoading(true)
            const data = {
                driverId: driver.driverId,
                orderId: orderId
            }


            await axios
                .post(`${ServerIP}/mission/takeMission`, data)
                .then(res => {
                    socketRef.current.emit('changeStatus', { orderId: orderId, statut: 'Start' });
                    setModalVisible(false);
                    setLoading(false);
                    setDriver({});
                })

        } catch (error) {
            setModalVisible(false);
            setLoading(false);
            setDriver({});
            console.log(error)
        }
    };


    //bottomSheet
    const [isVisible1, setIsVisible1] = useState(false);
    const [commentaryRating, setCommentaryRating] = useState([]);

    const cache = useRef(null);
    const listRef = useRef(null);

    const closeModal = () => {
        if (isVisible1 === true) {
            setCommentaryRating([]);
            setIsVisible1(false)
        }
    }



    if (!cache.current) {
        cache.current = new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 100
        });
    }

    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }

    }



    return (

        <div className="map-wrap">

            {modalVisible && (
                <div style={{
                    position: 'fixed', // Pour qu'il reste fixe même en scrollant
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fond noir transparent
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000 // S'assurer que le modal soit au-dessus de tout
                }}>
                    <div style={{
                        backgroundColor: '#fff', // Couleur de fond du modal
                        padding: '20px',
                        borderRadius: '10px',
                        width: '80%',
                        maxWidth: '400px',
                        textAlign: 'center',
                    }}>
                        <p style={{ fontSize: '17px', fontWeight: 700, fontFamily: 'Inter', color: colors.black, marginBottom: '20px' }}>
                            Êtes-vous sûr de vouloir voyager avec ce chauffeur ?
                        </p>

                        {(driver.price > promoMaxPriceAmount && promoStatut) && (
                            <WarningComponent warningMessage={`Le prix dépasse le montant maximum autorisé pour appliquer le code promo (${promoMaxPriceAmount} HTG).`} />
                        )}


                        <img src={driver?.profile} style={{ height: '100px', width: '100px', borderRadius: 300, marginBottom: '10px' }} />

                        <p style={{ fontSize: '15px', fontWeight: 700, fontFamily: 'Inter', color: colors.black, marginBottom: '10px' }}>
                            {driver.name}
                        </p>


                        {promoStatut && driver.price <= promoMaxPriceAmount ? (
                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'center', marginBottom: '10px', gap: 5 }}>

                                <p style={{ fontSize: '15px', fontWeight: 700, fontFamily: 'Inter', color: colors.gray, textDecoration: 'line-through' }}>
                                    {formatBalance(driver.price) + ' HTG'}
                                </p>

                                {discountType === 'Pourcentage' && (
                                    <p style={{ fontSize: '15px', fontWeight: 700, fontFamily: 'Inter', color: colors.secondary }}>
                                        {Math.round(driver.price - (driver.price * (promoDiscount / 100))) + ' HTG'}
                                    </p>
                                )}
                                {discountType === 'Fixe' && (
                                    <p style={{ fontSize: '15px', fontWeight: 700, fontFamily: 'Inter', color: colors.secondary }}>
                                        {formatBalance(driver.price - promoDiscount) + ' HTG'}
                                    </p>
                                )}
                            </div>
                        ) : (
                            <p style={{ fontSize: '15px', fontWeight: 700, fontFamily: 'Inter', color: colors.secondary, marginBottom: '10px' }}>
                                {formatBalance(driver.price) + ' HTG'}
                            </p>
                        )}





                        <div style={{ display: 'flex', flexDirection: 'row', gap: 10, padding: 20, marginTop: 20 }}>
                            <div
                                onClick={() => { setModalVisible(false); setDriver({}) }}
                                style={{
                                    width: '50%', alignSelf: 'center', display: 'flex', alignSelf: 'center', left: '5%', bottom: '25%',
                                    alignItems: 'center', justifyContent: 'center', height: '45px', backgroundColor: colors.gray2, borderRadius: '30px',
                                    fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 14
                                }}>
                                Annuler
                            </div>

                            <div
                                onClick={() => { takeTask() }}
                                style={{
                                    width: '50%', alignSelf: 'center', display: 'flex', alignSelf: 'center', left: '5%', bottom: '25%',
                                    alignItems: 'center', justifyContent: 'center', height: '45px', backgroundColor: "#C0EC4E", borderRadius: '30px',
                                    fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 14
                                }}>
                                Confirmer
                            </div>
                        </div>

                    </div>
                </div>
            )}


            {isVisible && (
                <div style={{ flexDirection: 'column', width: '100%', height: '100%', display: 'flex', borderTopRightRadius: 25, borderTopLeftRadius: 25, bottom: 0, backgroundColor: 'white', zIndex: 1 }}>

                    <span style={{ color: '#03031B', alignSelf: 'center', fontSize: 20, fontWeight: 700, fontFamily: 'Inter', marginTop: 90 }}>Modifier l'addresse</span>

                    <div style={{ padding: 20, marginTop: 20, marginBottom: 20 }}>
                        <textarea
                            defaultValue={address}
                            onChange={(event) => setAddress(event.target.value)}
                            style={{ width: '95%', height: '150%', borderRadius: 15, padding: 10, backgroundColor: '#FAFAFA', outline: 'none', }}
                        />
                    </div>


                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10, padding: 20, marginTop: 20 }}>
                        <div
                            onClick={() => { setIsVisible(false); setAddress([]); setAddressType('') }}
                            style={{
                                width: '50%', alignSelf: 'center', display: 'flex', alignSelf: 'center', left: '5%', bottom: '25%',
                                alignItems: 'center', justifyContent: 'center', height: '45px', backgroundColor: colors.gray2, borderRadius: '30px',
                                fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 14
                            }}>
                            Annuler
                        </div>

                        <div
                            onClick={() => {
                                changeAddress()
                            }}
                            style={{
                                width: '50%', alignSelf: 'center', display: 'flex', alignSelf: 'center', left: '5%', bottom: '25%',
                                alignItems: 'center', justifyContent: 'center', height: '45px', backgroundColor: "#C0EC4E", borderRadius: '30px',
                                fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 14
                            }}>
                            Confirmer
                        </div>
                    </div>

                </div>
            )}

            {!isVisible && (
                <div style={{ flexDirection: 'column', width: '100%', height: '100%', display: 'flex', borderTopRightRadius: 15, borderTopLeftRadius: 15, bottom: 0, backgroundColor: 'white' }}>

                    <div style={{ flexDirection: 'column', display: 'flex', width: '90%', height: '100%', alignItems: 'center', alignSelf: 'center', marginTop: '20px', backgroundColor: 'white' }}>

                        {/* <div style={{ height: '100px', width: '100px', borderRadius: 300, backgroundColor: '#FAFAFA', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                        </div> */}

                        <span style={{ color: '#03031B', fontSize: 20, fontWeight: 700, fontFamily: 'Inter', marginTop: 70 }}>En attente d'un chauffeur...</span>
                        <span style={{ fontSize: 13, marginTop: 5, fontWeight: 400, fontFamily: 'Inter', color: 'gray', textAlign: 'center' }}>Cela pourrait prendre un peu de temps</span>

                        <div style={{ borderWidth: 0.5, width: '95%', borderColor: colors.gray, marginTop: 20 }} />


                        <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'column' }}>
                            {/* <span style={{ color: colors.gray, fontSize: 14, fontWeight: '700', marginBottom:'5px', }}>Prix : </span> */}

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: colors.gray2, padding: '10px', borderRadius: '15px' }}>
                                {promoStatut && price <= promoMaxPriceAmount ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                        <span style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.gray, textDecoration: 'line-through' }}>
                                            {formatBalance(price) + ' HTG'}
                                        </span>
                                        {discountType === 'Pourcentage' && (
                                            <span style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.secondary }}>
                                                {Math.round(price - (price * (promoDiscount / 100))) + ' HTG'}
                                            </span>
                                        )}
                                        {discountType === 'Fixe' && (
                                            <span style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.secondary }}>
                                                {formatBalance(price - promoDiscount) + ' HTG'}
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    <span style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.secondary }}>
                                        {formatBalance(price) + ' HTG'}
                                    </span>
                                )}
                            </div>


                        </div>



                        <div style={{ borderBottomWidth: 0.5, width: '95%', borderColor: colors.gray2, marginTop: 20 }} />

                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 20, marginTop: 10, alignItems: 'center', justifyContent: 'center' }}>


                            <div style={{ height: 25, width: 25, borderRadius: 300, border: '2px solid #907EFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <div style={{ backgroundColor: '#907EFF', height: 20, width: 20, borderRadius: 300 }} />
                            </div>


                            <div style={{ width: '75%', borderRadius: '15px', padding: 10, backgroundColor: '#FAFAFA', display: 'flex', alignItems: 'center', }}>
                                <span style={{ fontSize: 13, fontWeight: 400, fontFamily: 'Inter', marginLeft: 10, color: 'gray' }}>{pickupAddress}</span>
                            </div>

                            <div
                                onClick={() => { setIsVisible(true); setAddress(pickupAddress); setAddressType('pickup') }}
                                style={{ height: 25, width: 25, borderRadius: 300 }}>
                                <EditOutlined style={{ color: colors.black, fontSize: '15px' }} />
                            </div>

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 20, marginTop: 5, alignItems: 'center', justifyContent: 'center' }}>


                            <FaCrosshairs size={30} color='#C0EC4E' style={{ marginRight: 0 }} />

                            <div style={{ width: '75%', borderRadius: '15px', padding: 10, backgroundColor: '#FAFAFA', display: 'flex', alignItems: 'center', }}>
                                <span style={{ fontSize: 13, fontWeight: 400, fontFamily: 'Inter', marginLeft: 10, color: 'gray' }}>{deliveredAddress}</span>
                            </div>
                            {/*setIsVisible(true); setAddress(deliveredAddress); setAddressType('delivered') */}
                            <div
                                onClick={() => { }}
                                style={{ height: 25, width: 25, borderRadius: 300 }}>
                            </div>

                        </div>

                        <hr style={{ borderBottomWidth: 0.5, width: '95%', borderColor: colors.gray2, marginTop: 20 }} />

                        <p style={{ fontSize: 20, fontWeight: 700, fontFamily: 'Inter', color: colors.black, alignSelf: 'flex-start' }}>Offres des chauffeurs</p>

                        <div style={{ height: '800px', width: '100%', overflowY: 'auto' }}>
                            {driverMissions.length === 0 ? (
                                <div style={{ padding: '20px', textAlign: 'center', color: colors.gray }}>
                                    <p style={{ fontSize: 18, fontWeight: 400, fontFamily: 'Inter', color: colors.gray }}>Aucune offre disponible pour l'instant.</p>
                                </div>
                            ) : (
                                driverMissions
                                    .sort((a, b) => a?.price - b.price)
                                    .map((mission, index) => (
                                        <div key={index} style={{ padding: '10px', marginBottom: '20px', backgroundColor: colors.gray2, borderRadius: '15px' }}>

                                            <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>

                                                <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'center' }}>
                                                    <div style={{ width: '20%' }}>
                                                        <img src={mission?.profile} style={{ height: '50px', width: '50px', borderRadius: 300 }} />
                                                    </div>

                                                    <div style={{ width: '80%', display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                                                        <p style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.black }} >{mission?.name}</p>
                                                        {mission.driverVerified && (<FaCheckCircle style={{ color: '#3498db', marginLeft: 5 }} size={16} />)}
                                                        <p style={{ fontSize: 16, fontFamily: 'Inter', fontWeight: 500, color: colors.black, marginLeft: 30 }} ><StarFilled size={20} style={{ color: '#fdd835' }} /> {mission?.rating}</p>
                                                    </div>
                                                </div>


                                                <div style={{ width: '100%', display: 'flex', gap: 5, }}>
                                                    <p style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.gray }}>Temps estime :</p>
                                                    <p style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter', color: colors.black }}>{getTimeFunc(mission?.latitude, mission?.longitude)} Min</p>
                                                </div>

                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 20 }}>

                                                {promoStatut && mission?.price <= promoMaxPriceAmount ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%', gap: 5 }}>

                                                        <p style={{ fontSize: '16px', fontWeight: 700, fontFamily: 'Inter', color: colors.gray, textDecoration: 'line-through' }}>
                                                            {formatBalance(mission?.price) + ' HTG'}
                                                        </p>

                                                        {discountType === 'Pourcentage' && (
                                                            <p style={{ color: colors.secondary, fontSize: '16px', fontWeight: 700, fontFamily: 'Inter' }}>
                                                                {Math.round(mission?.price - (mission?.price * (promoDiscount / 100))) + ' HTG'}
                                                            </p>
                                                        )}
                                                        {discountType === 'Fixe' && (
                                                            <p style={{ color: colors.secondary, fontSize: '16px', fontWeight: 700, fontFamily: 'Inter' }}>
                                                                {formatBalance(mission?.price - promoDiscount) + ' HTG'}
                                                            </p>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <p style={{ width: '30%', color: colors.secondary, fontSize: '16px', fontWeight: 700, fontFamily: 'Inter' }}>
                                                        {formatBalance(mission?.price) + ' HTG'}
                                                    </p>
                                                )}



                                                {mission?.finded ? (
                                                    <div
                                                        style={{
                                                            width: (promoStatut && mission?.price <= promoMaxPriceAmount) ? '50%' : '70%',
                                                            alignSelf: 'flex-end', display: 'flex', gap: 10,
                                                            alignItems: 'center', justifyContent: 'center', height: '40px', backgroundColor: colors.gray2, borderRadius: '30px',
                                                        }}>
                                                        <div style={{
                                                            display: 'flex', flexDirection: 'row',
                                                            alignItems: 'center', justifyContent: 'center', backgroundColor: colors.accent,
                                                            height: '40px', width: '20%', borderRadius: 300, gap: 5
                                                        }}>
                                                            <CommentOutlined style={{ color: colors.black, fontSize: 20 }} />
                                                            <span style={{ fontWeight: 700, fontFamily: 'Inter', color: colors.black, fontSize: 12, }}>{mission?.ratingHistory.length || 0}</span>
                                                        </div>

                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center', justifyContent: 'center',
                                                                fontWeight: 700, fontFamily: 'Inter', color: colors.gray, fontSize: 14, height: '40px', width: '78%'
                                                            }}>
                                                            Accepter
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        style={{
                                                            width: (promoStatut && mission?.price <= promoMaxPriceAmount) ? '50%' : '70%',
                                                            alignSelf: 'flex-end', display: 'flex', gap: 10,
                                                            alignItems: 'center', justifyContent: 'center', height: '40px', backgroundColor: colors.gray2, borderRadius: '30px',
                                                        }}>
                                                        <div
                                                            onClick={() => {
                                                                setIsVisible1(true);
                                                                setCommentaryRating(mission?.ratingHistory);
                                                            }}
                                                            style={{
                                                                display: 'flex', flexDirection: 'row',
                                                                alignItems: 'center', justifyContent: 'center', backgroundColor: colors.accent,
                                                                height: '40px', width: '20%', borderRadius: 300, gap: 5
                                                            }}>
                                                            <CommentOutlined style={{ color: colors.black, fontSize: 20 }} />
                                                            <span style={{ fontWeight: 700, fontFamily: 'Inter', color: colors.black, fontSize: 12, }}>{mission?.ratingHistory.length || 0}</span>
                                                        </div>

                                                        <div
                                                            onClick={() => {
                                                                setModalVisible(true);
                                                                setDriver({
                                                                    verified: mission?.driverVerified,
                                                                    driverId: mission?.driverId,
                                                                    name: mission?.name,
                                                                    price: mission?.price,
                                                                    profile: mission?.profile
                                                                })
                                                            }}
                                                            style={{
                                                                width: '78%',
                                                                alignSelf: 'flex-end', display: 'flex',
                                                                alignItems: 'center', justifyContent: 'center', height: '40px', backgroundColor: "#C0EC4E", borderRadius: '30px',
                                                                fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 14
                                                            }}>
                                                            Accepter
                                                        </div>
                                                    </div>
                                                )}

                                            </div>

                                        </div>
                                    )
                                    )
                            )}
                        </div>




                        {driverMissions.every(item => item.finded === true) && (
                            <span style={{ fontSize: 16, marginTop: 20, fontWeight: 700, fontFamily: 'Inter', color: '#907EFF', textAlign: 'center', alignSelf: 'center', marginLeft: 20, marginBottom: 20 }}>Vous pouvez retourner vers l'ecran d'acceuil</span>
                        )}

                    </div>
                </div>
            )}




            <Sheet
                isOpen={isVisible1}
                onClose={closeModal}
                snapPoints={[800]}
            >
                <Sheet.Container>
                    <Sheet.Header />
                    <Sheet.Content>


                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

                            <Loader visible={isVisible} />


                            <div style={{ alignSelf: 'flex-end', marginRight: '25px' }}>
                                <div style={{ height: '23px', width: '23px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    onClick={closeModal}>

                                    {isVisible1 !== false && <FontAwesomeIcon icon={faClose} size="lg" />}
                                </div>
                            </div>


                            <div style={{ display: 'flex', padding: '10px', flexDirection: "column" }}>
                                <p style={{ marginTop: '20px', fontFamily: 'Inter', fontSize: '16px', fontWeight: '700' }}>Commentaire</p>


                                {commentaryRating.length === 0 && (
                                    <div style={{ padding: '20px', height: '46%' }}>
                                        <div style={{ margin: '30px 0', textAlign: 'center' }}>
                                            <p style={{ fontSize: '16px', fontFamily: 'Inter', fontWeight: '700' }}>Aucun commentaires</p>
                                        </div>
                                    </div>
                                )}

                                {commentaryRating.length !== 0 && (
                                    <div style={{ height: '80%', display: 'flex' }}>

                                        <List
                                            width={1200}
                                            height={400}
                                            rowHeight={100}
                                            rowCount={commentaryRating.length}
                                            rowRenderer={({ index, key, style }) => {
                                                const rating = commentaryRating
                                                    .sort((a, b) => new Date(b.date) - new Date(a.date))  // Trier par date du plus récent au plus ancien
                                                [index];  // Obtenez l'élément à l'index courant

                                                // Format de date personnalisé : 14 juillet 2024
                                                const formattedDate = new Intl.DateTimeFormat('fr-FR', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: 'numeric',
                                                }).format(new Date(rating.date));

                                                return (
                                                    <div
                                                        key={key}
                                                        style={{
                                                            ...style,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            padding: '10px',
                                                            borderBottom: '1px solid #ddd',
                                                            backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff', // Alternance de couleur
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <span style={{ fontSize: '16px', fontFamily: 'Inter', fontWeight: '700' }}>
                                                                {rating.clientName.slice(0, 3) + '***'}
                                                            </span>
                                                            {rating.clientVerified && (
                                                                <FaCheckCircle style={{ color: '#3498db', marginLeft: 5 }} size={16} />
                                                            )}
                                                        </div>

                                                        <span style={{ margin: '5px 0', fontSize: '14px', fontFamily: 'Inter', fontWeight: '500' }}>
                                                            {rating.commentary || 'Aucun commentaire'}
                                                        </span>
                                                        <span style={{ fontSize: '12px', color: '#555', fontFamily: 'Inter', fontWeight: '500' }}>
                                                            Note : {rating.rating}{' '}
                                                            <StarFilled size={20} style={{ color: '#fdd835' }} /> | Type de service :{' '}
                                                            {rating.serviceType} | Date : {formattedDate}
                                                        </span>
                                                    </div>
                                                );
                                            }}
                                        />

                                    </div>
                                )}

                            </div>
                        </div>

                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>

            <Loader visible={loading} />

        </div >

    )
}

export default ClientRoutingMap;
